import logo from '../assets/Rihal_logo-fullcolor-rgb.svg'

const Footer = () => {
    return (
      <footer className="bg-gray-800 w-full text-white py-8 mt-16">
        <div className="max-w-6xl mx-auto flex justify-between items-center px-4">
          {/* Logo and Branding */}
          <div className="flex flex-col">
          <img src={logo} alt='logo' className='w-48 h-min hover:cursor-pointer m-2' /><span className='text-lg text-white mb-2 ml-6 font-light'><span className='text-gray-700 m-2'> | </span>  دليل سياحتك الحلال</span>
            <p className="text-lg text-gray-400 mt-2">
              اكتشف أفضل تجارب السفر الحلال حول العالم.
            </p>
          </div>
  
          {/* Links Section */}
          <div className="flex">
            <div className="space-y-2 space-x-10">
              <h4 className="text-xl font-semibold">روابط</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#home" className="hover:text-[#1cc752]">الرئيسية</a></li>
                <li><a href="#services" className="hover:text-[#1cc752]">الخدمات</a></li>
                <li><a href="#why-us" className="hover:text-[#1cc752]">لماذا نحن؟</a></li>
                <li><a href="#contact-us" className="hover:text-[#1cc752]">اتصل بنا</a></li>
              </ul>
            </div>
  
            <div className="space-y-4 ">
              <h4 className="text-xl font-semibold">معلومات</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="/aboutus" className="hover:text-[#1cc752]">من نحن</a></li>
                <li><a href="/privacy-policy" className="hover:text-[#1cc752]">سياسة الخصوصية</a></li>
                <li><a href="/terms" className="hover:text-[#1cc752]">الشروط والأحكام</a></li>
              </ul>
            </div>
          </div>
  
          {/* Social Media Links */}
          <div className="flex space-x-6 mx-4">
            <a href="https://facebook.com" className="text-gray-400 hover:text-[#1cc752]">
              <i className="fab fa-facebook-f text-2xl"></i>
            </a>
            <a href="https://twitter.com" className="text-gray-400 hover:text-[#1cc752]">
              <i className="fab fa-twitter text-2xl"></i>
            </a>
            <a href="https://instagram.com" className="text-gray-400 hover:text-[#1cc752]">
              <i className="fab fa-instagram text-2xl"></i>
            </a>
            <a href="https://linkedin.com" className="text-gray-400 hover:text-[#1cc752]">
              <i className="fab fa-linkedin-in text-2xl"></i>
            </a>
          </div>
        </div>
  
        {/* Copyright Section */}
        <div className="text-center text-gray-400 mt-8">
          <p>&copy; 2024 رحال. جميع الحقوق محفوظة.</p>
        </div>
      </footer>
    );
  };
  
  export default Footer;
  